import { Outlet } from 'react-router-dom';
import { Typography } from '@mui/material';

/**
 * Container for public share routes.
 * Provides a minimal layout without navigation.
 * Does NOT redirect authenticated users (unlike PublicRoutes).
 */
const PublicShareRoutes = () => {
  return (
    <div className="min-h-screen bg-zinc-900 flex flex-col">
      {/* Minimal header */}
      <header className="flex-shrink-0 px-6 py-4 border-b border-zinc-700 bg-zinc-800">
        <Typography variant="h6" component="span" sx={{ fontWeight: 600, color: 'white' }}>
          UrbanMix
        </Typography>
        <Typography variant="body2" component="span" sx={{ ml: 2, color: 'text.secondary' }}>
          Pricing Review
        </Typography>
      </header>

      {/* Main content */}
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
};

export default PublicShareRoutes;
